import type { Block, BlockRange, Inline, TextRange } from '../models';
import { isType, MODEL_TYPES } from './model-types';

/**
 * Check if `input` is a `Block`.
 */
export function isBlock(input: unknown): input is Block {
    return isType('BLOCK', input);
}

/**
 * Check if `input` is a `Inline`.
 */
export function isInline(input: unknown): input is Inline {
    return isType('INLINE', input);
}

/*
 * Check if an `obj` is a `TextRange`.
 */
export function isTextRange(obj: unknown): obj is TextRange {
    return Boolean(obj?.[MODEL_TYPES.TEXT_RANGE]);
}

/*
 * Check if an `maybeBlockRange` is a `BlockRange`.
 */
export function isBlockRange(maybeBlockRange: unknown): maybeBlockRange is BlockRange {
    return isType('BLOCK_RANGE', maybeBlockRange);
}
